import PrivacyPolicy from 'routes/PrivacyPolicy'

export default PrivacyPolicy
